import styled from "styled-components";

export const FlexRow = styled.div`
    display:flex;
    align-items:center;
    padding-top:20px;
    padding-bottom:20px;
    
`
export const UserName = styled.h5`
    color:black;
    margin-left:10px;
    margin-right:10px;
    font-size:17px;
    display:flex;
    white-space: nowrap;
    font-family: sans-serif;

`;

